module.exports = __webpack_public_path__ + "img/download.3edc8ff6.svg";